import { render, staticRenderFns } from "./PrivacyModal.vue?vue&type=template&id=733ccbfa&scoped=true"
var script = {}
import style0 from "./PrivacyModal.vue?vue&type=style&index=0&id=733ccbfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ccbfa",
  null
  
)

export default component.exports